const $BASE_API = "https://apijedstion.desajeds.com.ar";
const $BASE_REST = "https://apijedstion.desajeds.com.ar/web"; // Desarrollo
// const $BASE_REST = "https://apijedstion.projeds.com"; // Produccion
// const $BASE_REST = "http://localhost/jedstion_backend/web"; // Local

export const environment = {
      production: false,
      baseRest: $BASE_REST,
      view_ss_iva: `${$BASE_REST}/view_ss_iva/index`,
      login: {
            users: `${$BASE_REST}/view_usuario_logins`,
            login: `${$BASE_REST}/usuario/login`,
            view_usuarios: `${$BASE_REST}/view_usuarios`,
            credencial_usuario: `${$BASE_REST}/view_usuario/generar_credencial`
      },
      administracion: {
            tratamientos: `${$BASE_REST}/tratamientos`,
            select_tratamientos: `${$BASE_REST}/select?modelo=Tratamiento&campo_id=idtratamiento&campo_descripcion=descripcion&campo_activo=activo`,
            bancos: `${$BASE_REST}/fondos_bancos`,
            proveedores: `${$BASE_REST}/proveedors`,
            proveedores_token: `${$BASE_REST}/proveedor_tokens`,
            banco_token: `${$BASE_REST}/fondos_banco_token`,
            tratamiento_token: `${$BASE_REST}/tratamiento_token`,
            proveedor_token: `${$BASE_REST}/proveedor_token`,
            view_proveedor_token: `${$BASE_REST}/view_proveedor_token`,
            view_proveedores: `${$BASE_REST}/view_proveedors`,
            view_ven_pago_tipos: `${$BASE_REST}/view_ven_pago_tipos`,
            ven_pago_tipos: `${$BASE_REST}/ven_pago_tipos`,
            clientes: `${$BASE_REST}/adm_clientes`,
            cliente_cuenta_corriente: `${$BASE_REST}/cliente/cc`,
            view_clientes: `${$BASE_REST}/view_clientes`,
            select_clientes: `${$BASE_REST}/select?modelo=Cliente&campo_id=codigo&campo_descripcion=razonSocial&campo_activo=activo&sort=razonSocial`,
            view_compras_tipo_pago: `${$BASE_REST}/view_compras_tipo_pago`,
            compras_tipo_pagos: `${$BASE_REST}/compras_tipo_pagos`,
            condicion_iva: `${$BASE_REST}/select?modelo=Condicioniva&campo_id=codigo&campo_descripcion=descripcion&campo_activo=activo`,
            vta_cobro_tipos: `${$BASE_REST}/vta_cobro_tipos`,
            view_vta_cobro_tipos: `${$BASE_REST}/view_vta_cobro_tipos`,
            estados_ventas: `${$BASE_REST}/com_estados`,
            select_estados: `${$BASE_REST}/select?modelo=ComEstado&campo_id=idestado&campo_descripcion=descripcion&campo_activo=activo&sort=descripcion`,
            clientes_consultar_persona: `${$BASE_REST}/adm_cliente/consultar_persona`,
            proveedor_cuenta_corriente: `${$BASE_REST}/proveedor/cc`,
            proveedores_consultar_persona: `${$BASE_REST}/proveedor_token/consultar_persona`,
            view_cc_cliente_resumen: `${$BASE_REST}/view_cc_cliente_resumen`,
            view_cc_cliente_resumen_exportar_pdf: `${$BASE_REST}/view_cc_cliente_resumen/exportar_pdf`,
            view_cc_proveedor_resumen: `${$BASE_REST}/view_cc_proveedor_resumen`,
            view_cc_proveedor_resumen_exportar_pdf: `${$BASE_REST}/view_cc_proveedor_resumen/exportar_pdf`
      },
      fondos: {
            fondos: `${$BASE_REST}/fondos_fondos`,
            fondos_token: `${$BASE_REST}/fondos_fondo_tokens`,
            view_fondos: `${$BASE_REST}/view_fondos`,
            fondos_tipo: `${$BASE_REST}/fondos_tipos`,
            movimientos: `${$BASE_REST}/fondos_movimientos`,
            view_movimientos: `${$BASE_REST}/view_movimientos`
      },
      stock: {
            articulos: `${$BASE_REST}/stk_articulos`,
            get_datos_articulo: `${$BASE_REST}/stk_articulo/get_datos?idarticulo=`,
            articulo_unidad_medidas: `${$BASE_REST}/stk_articulo_unidad_medidas`,
            movimientos_articulo: `${$BASE_REST}/stk_articulo/movimientos`,
            stk_articulo_interpretar_formula: `${$BASE_REST}/stk_articulo/interpretar_formula`,
            stk_articulo_aplicar_formula: `${$BASE_REST}/stk_articulo/aplicar_formula`,
            stk_articulo_actualizar_precios: `${$BASE_REST}/stk_articulo/actualizar_precios`,
            stk_articulo_actualizar_utilidad: `${$BASE_REST}/stk_articulo/actualizar_utilidad`,
            stk_articulo_actualizar_utilidad_grupal: `${$BASE_REST}/stk_articulo/actualizar_utilidad_grupal`,
            depositos: `${$BASE_REST}/stk_depositos`,
            entregas: `${$BASE_REST}/stk_entregas`,
            entregas_rapidas_index: `${$BASE_REST}/stk_entrega/index_rapidas`,
            entregas_rapidas_create: `${$BASE_REST}/stk_entrega/create_rapida`,
            entregas_rapidas_get_datos: `${$BASE_REST}/stk_entrega/get_datos_rapida?id=`,
            entregas_rapidas_update: `${$BASE_REST}/stk_entrega/update_rapida?id=`,
            entregas_rapidas_despachar_precarga: `${$BASE_REST}/stk_entrega/despachar_precarga?id=`,
            entregas_rapidas_despachar_masivo: `${$BASE_REST}/stk_entrega/despachar_masivo`,
            entregas_rapidas_get_permisos: `${$BASE_REST}/stk_entrega/get_permisos`,
            entregas_rapidas_anular: `${$BASE_REST}/stk_entrega/anular_rapida?id=`,
            entregas_get_datos: `${$BASE_REST}/stk_entrega/get_datos?id=`,
            stk_entrega_externas_por_venta: `${$BASE_REST}/stk_entrega/externas_por_venta`,
            unidad_medidas: `${$BASE_REST}/stk_unidad_medidas`,
            movimiento_conversion: `${$BASE_REST}/stk_movimiento_conversions`,
            view_stock_movimiento_conversion: `${$BASE_REST}/view_stock_movimiento_conversion`,
            movimiento_internos: `${$BASE_REST}/stk_movimiento_internos`,
            view_movimiento_internos: `${$BASE_REST}/view_movimiento_internos`,
            remitos: `${$BASE_REST}/stk_remitos`,
            rubros: `${$BASE_REST}/stk_rubros`,
            reporte_etiqueta: `${$BASE_REST}/stk_articulo/generar_etiquetas`,
            reporte_entrega: `${$BASE_REST}/stk_entrega/generar_reporte?identrega=`,
            reporte_movimiento_internos: `${$BASE_REST}/stk_movimiento_interno/generar_reporte?idmovimientointerno=`,
            stock_inicial: `${$BASE_REST}/stk_stock_inicials`,
            stock_inicial_get_datos: `${$BASE_REST}/stk_stock_inicial/get_datos?idstockinicial=`,
            ver_imagen: `${$BASE_REST}`, // uploads/nombre_imagen se lo concatena en otros componentes
            view_articulos: `${$BASE_REST}/view_articulos`,
            view_stock_inicials: `${$BASE_REST}/view_stock_inicials`,
            view_stock_movimientos: `${$BASE_REST}/view_stock_movimientos`,
            ver_reporte_movimiento_internos: `${$BASE_REST}/`,
            view_stock_articulo_depositos: `${$BASE_REST}/view_stock_articulo_depositos`,
            view_stock_articulo_unidad_medidas: `${$BASE_REST}/view_stock_articulo_unidad_medidas`,
            view_items_oc_pendientes: `${$BASE_REST}/view_items_oc_pendientes`,
            view_stock_entregas: `${$BASE_REST}/view_stock_entregas`,
            view_stock_depositos: `${$BASE_REST}/view_stock_depositos`,
            view_stock_remitos: `${$BASE_REST}/view_stock_remitos`,
            view_devolucion_pendiente: `${$BASE_REST}/view_devolucion_pendientes`,
            view_inventarios: `${$BASE_REST}/view_inventarios`,
            entregar: `${$BASE_REST}/stk_entrega/entregar?identrega=`,
            stk_entrega_puede_crear: `${$BASE_REST}/stk_entrega/puede_crear`,
            stk_articulo_adjuntos: `${$BASE_REST}/stk_articulo/adjuntos`,
            stk_articulo_obtener_adjuntos: `${$BASE_REST}/stk_articulo/obtener_adjuntos`,
            stk_articulo_ordenar: `${$BASE_REST}/stk_articulo/ordenar`,
            stk_movimiento_devolucion: `${$BASE_REST}/stk_movimiento_devolucions`,
            stk_inventario: `${$BASE_REST}/stk_inventarios`,
            stk_inventario_get_datos: `${$BASE_REST}/stk_inventario/get_datos?idinventario=`,
            dashboard_resumen: `${$BASE_REST}/stk_dashboard/resumen`,
            dashboard_stock_general: `${$BASE_REST}/stk_dashboard/stock_general`,
            dashboard_movimientos: `${$BASE_REST}/stk_dashboard/movimientos`,
            dashboard_oc_pendientes: `${$BASE_REST}/stk_dashboard/oc_pendientes`,
            dashboard_alertas_criticas: `${$BASE_REST}/stk_dashboard/alertas_criticas`,
            evaluar_stock: `${$BASE_REST}/view_stk_movimiento/evaluar_stock`,
            evaluar_movimiento: `${$BASE_REST}/view_stk_movimiento/evaluar_movimiento`,
            entregas_externas: `${$BASE_REST}/stk_entrega/index_externas`,
            devoluciones_externas: `${$BASE_REST}/stk_movimiento_devolucion/index_externas`,
            articulos_entregables: `${$BASE_REST}/stk_entrega/articulos_entregables_por_venta?idventa=`,
            articulos_devolvibles: `${$BASE_REST}/stk_movimiento_devolucion/articulos_devolvibles_por_venta?idventa=`,
            create_entrega_externa: `${$BASE_REST}/stk_entrega/create_externa`,
            create_devolucion_externa: `${$BASE_REST}/stk_movimiento_devolucion/create`,
            stk_entrega_get_datos: `${$BASE_REST}/stk_entrega/get_datos?id=`,
            update_entrega_externa: `${$BASE_REST}/stk_entrega/update_externa?id=`,
            delete_entrega_externa: `${$BASE_REST}/stk_entrega/delete_externa?id=`,
            historial_devoluciones: `${$BASE_REST}/stk_movimiento_devolucion/historial_externas_por_venta?idventa=`,
            stk_devolucion_get_datos: `${$BASE_REST}/stk_movimiento_devolucion/get_datos?id=`,
            update_devolucion_externa: `${$BASE_REST}/stk_movimiento_devolucion/update?id=`,
            delete_devolucion_externa: `${$BASE_REST}/stk_movimiento_devolucion/delete?id=`,
      },
      ventas: {
            vta_obra: `${$BASE_REST}/vta_obra`,
            vta_obra_search: `${$BASE_REST}/vta_obra/search`,
            vta_obra_create: `${$BASE_REST}/vta_obra/create`,
            vta_obra_update: `${$BASE_REST}/vta_obra/update`,
            vta_obra_delete: `${$BASE_REST}/vta_obra/delete`,
            vta_obra_seguimiento: `${$BASE_REST}/vta_obra/seguimiento`,
            vta_obra_ventas: `${$BASE_REST}/vta_obra/ventas`,
            vta_ventas: `${$BASE_REST}/vta_ventas`,
            vta_venta_calcular_item: `${$BASE_REST}/vta_venta/calcular_item`,
            vta_venta_calcular_unitario: `${$BASE_REST}/vta_venta/calcular_unitario`,
            vta_venta_get_datos: `${$BASE_REST}/vta_venta/get_datos`,
            nuevo_adicional: `${$BASE_REST}/vta_venta/nuevo_adicional`,
            generar_venta: `${$BASE_REST}/vta_venta/convertir_a_venta`,
            recotizar: `${$BASE_REST}/vta_venta/recotizar`,
            generar_reporte_venta: `${$BASE_REST}/vta_venta/generar_reporte_venta`,
            view_vta_ventas: `${$BASE_REST}/view_vta_ventas`,
            view_vta_venta_bonificado_detalles: `${$BASE_REST}/view_vta_venta_bonificado_detalles`,
            view_vta_venta_selects: `${$BASE_REST}/view_vta_venta_selects`,
            view_venta_selects: `${$BASE_REST}/view_venta_selects`,
            view_venta_genericas: `${$BASE_REST}/view_venta_genericas`,
            vta_cobro_tipo: `${$BASE_REST}/vta_cobro_tipo`,
            calcular_importe: `${$BASE_REST}/vta_cobro/calcular_importe`,
            cargar_item_cobro_calculadora: `${$BASE_REST}/vta_cobro/cargar_item_cobro_calculadora`,
            generar_reporte_calculadora: `${$BASE_REST}/vta_cobro/generar_reporte_calculadora`,
            generar_reporte_cobro: `${$BASE_REST}/vta_cobro/generar_reporte_cobro`,
            create_anticipo: `${$BASE_REST}/vta_cobro/create_anticipo`,
            get_anticipos_disponibles: `${$BASE_REST}/vta_cobro/get_anticipos_disponibles`,
            aplicar_anticipo: `${$BASE_REST}/vta_cobro/aplicar_anticipo`,
            view_vta_cobros_indicadores: `${$BASE_REST}/view_vta_cobro/indicadores`,
            view_vta_cobros_agrupados: `${$BASE_REST}/view_vta_cobro/agrupados_por_cliente`,
            view_vta_cobros_adjuntos: `${$BASE_REST}/view_vta_cobro/adjuntos`,
            view_vta_cobros: `${$BASE_REST}/view_vta_cobro`,
            view_cliente: `${$BASE_REST}/view_cliente`,
            view_vta_venta_pendiente: `${$BASE_REST}/view_vta_venta_pendiente`,
            fondos_bancos: `${$BASE_REST}/fondos_bancos`,
            calcular_interes: `${$BASE_REST}/vta_cobro/calcular_interes`,
            cargar_item_cobro: `${$BASE_REST}/vta_cobro/cargar_item_cobro`,
            cargar_forma_cobro: `${$BASE_REST}/vta_cobro/cargar_forma_cobro`,
            vta_cobros: `${$BASE_REST}/vta_cobros`,
            get_datos: `${$BASE_REST}/vta_cobro/get_datos`,
            view_vta_venta_estados: `${$BASE_REST}/view_vta_venta_estados`,
            vta_venta_estados: `${$BASE_REST}/vta_venta_estados`,
            get_datos_empresa: `${$BASE_REST}/fe_factura/get_datos_empresa`,
            view_fe_facturas: `${$BASE_REST}/view_fe_facturas`,
            comprobantes_por_venta: `${$BASE_REST}/fe_factura/get_comprobantes_por_venta`,
            fe_facturas: `${$BASE_REST}/fe_facturas`,
            fe_facturas_enviar_factura: `${$BASE_REST}/fe_factura/enviar_factura`,
            fe_facturas_exportar: `${$BASE_REST}/fe_factura/exportar`,
            reporte_comprobante_pdf: `${$BASE_REST}/fe_factura/reporte_comprobante_pdf`,
            reporte_comprobante_con_adjuntos_pdf: `${$BASE_REST}/fe_factura/reporte_comprobante_con_adjuntos_pdf`,
            asociar_cobro: `${$BASE_REST}/fe_factura/asociar_cobro`,
            generar_comprobante_factura: `${$BASE_REST}/fe_factura/generar_comprobante`,
            get_datos_factura: `${$BASE_REST}/fe_factura/get_datos`,
            get_items_para_facturar: `${$BASE_REST}/fe_factura/get_items_para_facturar?ids_venta=`,
            ultimo_comprobante_autorizado: `${$BASE_REST}/fe_factura/ultimo_comprobante_autorizado`,
            creacion_multiple: `${$BASE_REST}/fe_factura/creacion_multiple`,
            generar_lote: `${$BASE_REST}/fe_factura/generar_lote`,
            get_tipos_comprobantes: `${$BASE_REST}/fe_factura/get_tipos_comprobantes`,
            view_vta_pagare: `${$BASE_REST}/view_vta_pagare`,
            generar_reporte_pagare: `${$BASE_REST}/view_vta_pagare/generar_reporte_pagare?idcobroformapago=`,
            get_depositos_con_stock: `${$BASE_REST}/vta_venta/get_depositos_con_stock?idventa=`,
            generar_orden_servicio: `${$BASE_REST}/vta_venta/generar_orden_servicio`,
            generar_remito_entrega: `${$BASE_REST}/vta_venta/generar_remito_entrega`,
            // Prospectos
            view_prospectos: `${$BASE_REST}/view_prospecto`,
            vta_prospectos: `${$BASE_REST}/vta_prospectos`,
            vta_prospecto_adjunto: `${$BASE_REST}/vta_prospecto_adjunto`,
            view_vta_venta: `${$BASE_REST}/view_vta_venta`,
            get_items_a_valorizar: `${$BASE_REST}/vta_venta/get_items_a_valorizar`,
            valorizar_items: `${$BASE_REST}/vta_venta/valorizar`,
            enviar_email: `${$BASE_REST}/vta_venta/enviar-email`,
            obtener_datos_envio: `${$BASE_REST}/vta_venta/obtener-datos-envio`,
            get_asociables: `${$BASE_REST}/fe_factura/get_asociables`,
            asociar_factura: `${$BASE_REST}/vta_venta/asociar_factura`,
            vta_venta_get_adjuntos: `${$BASE_REST}/vta_venta/get_adjuntos`,
            get_facturas_asociadas: `${$BASE_REST}/vta_venta/get_facturas_asociadas`,
            get_ventas_asociadas: `${$BASE_REST}/fe_factura/get_ventas_asociadas`,
            permisos_punto_venta: `${$BASE_REST}/vta_venta/permisos_punto_venta`,
            permisos_facturacion: `${$BASE_REST}/fe_factura/permisos_facturacion`
      },
      compras: {
            compras_cotizacion: `${$BASE_REST}/compras_cotizacion`,
            compras_factura: `${$BASE_REST}/compras_factura`,
            compras_factura_get_datos: `${$BASE_REST}/compras_factura/get_datos?idfactura=`,
            compras_pedidos: `${$BASE_REST}/compras_pedidos`,
            compras_pedidos_enviar_presupuesto: `${$BASE_REST}/compras_pedido/enviar_presupuesto`,
            compras_periodo: `${$BASE_REST}/compras_periodo`,
            compras_periodo_periodos: `${$BASE_REST}/compras_periodo/periodos`,
            compras_periodo_nuevo: `${$BASE_REST}/compras_periodo/nuevo`,
            compras_periodo_eliminar: `${$BASE_REST}/compras_periodo/eliminar`,
            compras_periodo_cerrar: `${$BASE_REST}/compras_periodo/cerrar`,
            generar_reporte_pedido: `${$BASE_REST}/compras_pedido/generar_reporte_pedido?idpedido=`,
            view_compras_pedidos: `${$BASE_REST}/view_compras_pedidos`,
            view_compras_pedido_item: `${$BASE_REST}/view_compras_pedido_item`,
            compras_orden_compra: `${$BASE_REST}/compras_orden_compras`,
            generar_reporte_orden_compra: `${$BASE_REST}/compras_orden_compra/generar_reporte_orden_compra?idordencompra=`,
            compras_orden_compra_items: `${$BASE_REST}/compras_orden_compra_items`,
            compras_orden_compra_cotizacion: `${$BASE_REST}/compras_orden_compra/cotizacion`,
            compras_orden_compra_enviar_orden_compra: `${$BASE_REST}/compras_orden_compra/enviar_orden_compra`,
            compras_orden_compra_confirmar_envio: `${$BASE_REST}/compras_orden_compra/confirmar_envio`,
            view_orden_compras: `${$BASE_REST}/view_orden_compras`,
            view_orden_compra_pendiente: `${$BASE_REST}/view_orden_compra_pendiente`,
            view_compras_cotizacion: `${$BASE_REST}/view_compras_cotizacion`,
            view_compras_cotizacion_item: `${$BASE_REST}/view_compras_cotizacion_item`,
            view_compras_pago: `${$BASE_REST}/view_compras_pagos`,
            compras_pago_pendientes: `${$BASE_REST}/compras_pago/pendientes`,
            compras_tipos_pago: `${$BASE_REST}/compras_pago/tipos_pago`,
            compras_pago_guardar: `${$BASE_REST}/compras_pago/guardar`,
            compras_pago_guardar_anticipo: `${$BASE_REST}/compras_pago/guardar_anticipo`,
            compras_pago_guardar_orden_pago: `${$BASE_REST}/compras_pago/guardar_orden_pago`,
            compras_pago_guardar_facturas: `${$BASE_REST}/compras_pago/guardar_facturas`,
            compras_pago_get_listado: `${$BASE_REST}/compras_pago/get_listado`,
            compras_pago_anticipos_disponibles: `${$BASE_REST}/compras_pago/get_anticipos_disponibles`,
            compras_pago_saldos_proveedores: `${$BASE_REST}/compras_pago/get_saldos_proveedores`,
            compras_pago_kpis: `${$BASE_REST}/compras_pago/kpis`,
            compras_pago_eliminar: `${$BASE_REST}/compras_pagos`,
            get_datos_compras_pago: `${$BASE_REST}/compras_pago/get_datos`,
            view_compras_factura_listados: `${$BASE_REST}/view_compras_factura_listado`,
            generar_reporte_orden_pago: `${$BASE_REST}/compras_pago/generar_reporte_orden_pago?idpago=`,
            generar_reporte_retenciones: `${$BASE_REST}/compras_pago/generar_reporte_retenciones?idpago=`,
            compras_orden_pago_enviar_orden_pago: `${$BASE_REST}/compras_pago/enviar_orden_pago`,
            compras_orden_compra_get_datos_ajuste: `${$BASE_REST}/compras_orden_compra/get_datos_ajuste?idordencompra=`,
            compras_orden_compra_persistir_ajuste: `${$BASE_REST}/compras_orden_compra/persistir_ajuste`,
            view_cer_tareas: `${$BASE_REST}/view_cer_tarea`,
            cer_tareas: `${$BASE_REST}/cer_tareas`,
            editar_tarea: `${$BASE_REST}/cer_tarea/editar_tarea?id=`,
            generar_reporte_tarea: `${$BASE_REST}/cer_tarea/generar_reporte_tarea?idtarea=`,
            compras_pago_multiple_sueldos: `${$BASE_REST}/compras_pago/pago-multiple-sueldos`,
      },
      localidades: `${$BASE_REST}/com_localidads`,
      view_com_localidad_provincia: `${$BASE_REST}/view_com_localidad_provincias`,
      controlador: `${$BASE_API}/controlador`,
      menu: `${$BASE_REST}/com_menus`,
      com_documentacions: `${$BASE_REST}/com_documentacions`,
      estado_microservicios: `${$BASE_REST}/estado_microservicios`,
      tipo_cambio: `${$BASE_REST}/com_tipo_cambio/get_cotizacion_actual`,
      empresa: {
            api: `${$BASE_REST}/com_menus`,
            uploads: `${$BASE_REST}`,
      },
      notificaciones: {
            view_notificaciones: `${$BASE_REST}/view_notificacions`,
            view_notificaciones_group: `${$BASE_REST}/view_notificacion_group`
      },
      inmuebles: {
            complejos: {
                  inm_complejos: `${$BASE_REST}/inm_complejos`,
                  view_inm_complejos: `${$BASE_REST}/view_inm_complejos`
            },
            unidad_funcional: {
                  inm_unidad_funcional: `${$BASE_REST}/inm_unidad_funcional`,
                  view_inm_unidad_funcional: `${$BASE_REST}/view_inm_unidad_funcionals`
            }
      },
      reporte_orden_servicio: `${$BASE_REST}/generar_orden_servicios`,
      configuracion: `${$BASE_REST}/com_configuracion`,
      internos: {
            view_internos: `${$BASE_REST}/view_internos`,
            view_interno_documentacions: `${$BASE_REST}/view_interno_documentacions?filter[idinterno]=`,
            selects: `${$BASE_REST}/selects`,
            int_modelos: `${$BASE_REST}/int_modelos`,
            int_marcas: `${$BASE_REST}/int_marcas`,
            int_internos: `${$BASE_REST}/int_internos`,
            int_interno: `${$BASE_REST}/int_interno`
      },
      seguridad: {
            usuarios: `${$BASE_REST}/usuarios`,
            reset_password: `${$BASE_REST}/usuario/reset_password`,
            change_password: `${$BASE_REST}/usuario/change_password`,
            seg_usuario_rols: `${$BASE_REST}/seg_usuario_rols`,
            menues: {
                  view_com_menus: `${$BASE_REST}/view_com_menus`,
                  crear_menu: `${$BASE_REST}/com_menu/crear`,
                  com_menus: `${$BASE_REST}/com_menus`
            },
            empresas: {
                  view_empresas: `${$BASE_REST}/view_emp_empresas`,
                  emp_empresas: `${$BASE_REST}/emp_empresas`,
                  view_emp_empresa_mails: `${$BASE_REST}/view_emp_empresa_mails`,
                  emp_empresa_mails: `${$BASE_REST}/emp_empresa_mails`,
                  emp_empresa_alta_certificado: `${$BASE_REST}/emp_empresa/alta_certificado`,
                  emp_empresa_estado_certificado: `${$BASE_REST}/emp_empresa/estado_certificado`
            },
            items: {
                  seg_items: `${$BASE_REST}/seg_items`
            },
            roles: {
                  seg_rols: `${$BASE_REST}/seg_rols`,
                  view_seg_usuario_rol: `${$BASE_REST}/view_seg_usuario_rol`,
                  view_seg_permiso: `${$BASE_REST}/view_seg_permiso`,
                  seg_permisos: `${$BASE_REST}/seg_permisos`,
                  replicar_permisos: `${$BASE_REST}/seg_permiso/replicar_permisos`,
            }
      },
      rrhh: {
            empleados: {
                  view_rh_empleados: `${$BASE_REST}/view_rh_empleados`,
                  rh_empleados: `${$BASE_REST}/rh_empleados`
            },
            novedades: {
                  view_rh_novedads: `${$BASE_REST}/view_rh_novedads`,
                  rh_novedads: `${$BASE_REST}/rh_novedads`,
                  cargar_novedad: `${$BASE_REST}/rh_empleado/cargar_novedad`,
                  eliminar_novedad: `${$BASE_REST}/rh_empleado/eliminar_novedad`
            },
            documentacion: {
                  view_rh_documentacions: `${$BASE_REST}/view_rh_documentacions`,
                  cargar_documentacion: `${$BASE_REST}/rh_empleado/cargar_documentacion`,
                  eliminar_documentacion: `${$BASE_REST}/rh_empleado/eliminar_documentacion`
            },
            ofertas_laborales: {
                  view_rh_oferta_laboral: `${$BASE_REST}/view_rh_oferta_laborals`,
                  rh_oferta_laboral: `${$BASE_REST}/rh_oferta_laborals`,
                  get_datos: `${$BASE_REST}/rh_oferta_laboral/get_datos?idofertalaboral=`
            },
            postulaciones: {
                  view_rh_postulacions: `${$BASE_REST}/view_rh_postulacions`
            }
      },
      recordatorios: {
            view_recordatorios: `${$BASE_REST}/view_recordatorios`,
            view_recordatorio_detalle: `${$BASE_REST}/view_recordatorio_detalle`,
            reprogramar_recordatorio: `${$BASE_REST}/com_recordatorio/reprogramar_recordatorio`,
            finalizar_recordatorio: `${$BASE_REST}/com_recordatorio/finalizar_recordatorio`,
            crear_recordatorio: `${$BASE_REST}/com_recordatorio/create`,
      },
      soporte: {
            crear_ticket: `${$BASE_REST}/ticket/create`,
            listado_tickets: `${$BASE_REST}/ticket`,
            intercambiar_prioridad: `${$BASE_REST}/ticket/intercambiar_prioridad`,
            actualizar_prioridad: `${$BASE_REST}/ticket/actualizar_prioridad`,
            base_adjuntos: 'https://apiregistro.projeds.com',
            epics_en_curso: `${$BASE_REST}/epic/en-curso`,
            epics_pendientes: `${$BASE_REST}/epic/pendientes`,
            epics_modulos: `${$BASE_REST}/epic/modulos`,
            epics_crear_modulo: `${$BASE_REST}/epic/crear-modulo`,
            epics_sectores: `${$BASE_REST}/epic/sectores`,
            epics_crear: `${$BASE_REST}/epic/crear`,
            epics_editar: `${$BASE_REST}/epic/editar`,
            epics_desplazar_prioridad: `${$BASE_REST}/epic/desplazar-prioridad`
      },
      indicadores_centro_costo: {
            kpis: `${$BASE_REST}/indicadores_centro_costo/kpis`,
            resumen: `${$BASE_REST}/indicadores_centro_costo/resumen`,
            grafico: `${$BASE_REST}/indicadores_centro_costo/grafico`,
            centros: `${$BASE_REST}/indicadores_centro_costo/centros`,
            dashboard: `${$BASE_REST}/indicadores_centro_costo/dashboard`
      }
};
